import { render, staticRenderFns } from "./ItemsBox.vue?vue&type=template&id=e8271576&"
import script from "./ItemsBox.vue?vue&type=script&lang=js&"
export * from "./ItemsBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports